<template>
  <div id="app">
    <transition name="fade" mode="out-in" @before-enter="beforeEnter" appear>
      <router-view />
    </transition>
    <a
      href="https://api.whatsapp.com/send/?phone=6281113901291&text=Halo"
      target="_blank"
      rel="noopener noreferrer"
      class="whatsapp-button"
      v-if="!isVerySmall && $route.name != 'CustomProductPage'"
      ><span uk-icon="whatsapp"></span
    ></a>
    <a
      href="https://api.whatsapp.com/send/?phone=6281113901291&text=Halo"
      target="_blank"
      rel="noopener noreferrer"
      class="whatsapp-button-mobile"
      v-else-if="$route.name != 'CustomProductPage'"
    >
      <span uk-icon="whatsapp"></span
    ></a>
  </div>
</template>

<style lang="less">
// @import "../node_modules/uikit/src/less/uikit.less";
@import "custom/custom.less";

.whatsapp-button {
  position: fixed;
  width: 50px;
  height: 50px;
  bottom: 40px;
  right: 30px;
  background-color: #fff;
  color: #25d366;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.175);
  z-index: 100;
}

.whatsapp-button:hover {
  color: #25d366;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.4);
}

.whatsapp-button:active,
.whatsapp-button:visited {
  color: #fff;
}

.my-whatsapp-button {
  margin-top: 10px;
}

.whatsapp-button-mobile {
  position: fixed;
  width: 45px;
  height: 45px;
  bottom: 20px;
  right: 15px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 26px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.175);
  z-index: 100;
}

.whatsapp-button-mobile:hover {
  color: #fff;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.4);
}

.whatsapp-button-mobile:active,
.whatsapp-button-mobile:visited {
  color: #fff;
}

.my-whatsapp-button-mobile {
  margin-top: 8px;
}

.uk-modal-dialog {
  .uk-modal-header {
    padding-left: 0px;
    .uk-modal-title {
      font-size: 1.5rem;
      letter-spacing: normal;
      text-transform: capitalize;
    }
  }
  .uk-modal-body {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.uk-button {
  letter-spacing: normal;
  text-transform: capitalize;
}

.uk-button-small {
  font-size: 12px !important;
}

// remove arrow on input type number
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

a:hover {
  text-decoration: none;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.uk-container-mobile {
  padding-left: 8.5vw !important;
  padding-right: 8.5vw !important;
}
</style>

<style>
@import url("https://fonts.googleapis.com/css?family=Quicksand:300,400,500,600,700&display=swap");

/* * {
    font-family: 'Quicksand';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
} */

/* html, body { */
/* font-family: 'Quicksand'; */
/* -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
} */

.uk-container {
  padding-left: 8.5vw;
  padding-right: 8.5vw;
}

.primary-background {
  background-color: rgb(45, 61, 120) !important;
  color: #ffffff !important;
}

/* transition effect styling */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import { mapActions, mapGetters, mapMutations } from "vuex";
import $axios from '@/api.js'

UIkit.use(Icons);

export default {
  name: "App",
  methods: {
    ...mapActions("cart", ["getCarts"]),
    ...mapMutations(["SET_ALERT", 'SET_DURATION_OTP', 'SET_NOTIF_ORDER']),
    beforeEnter: function () {
      // make scroll position always on top every page transition
      this.$root.$emit("scrollBeforeEnter");
    },
    getNotif() {
      if (this.IS_AUTH) {
        $axios.post('customer/riwayat_pesanan/notif_pesanan', {
          id_cust: this.GET_USER.id,
        }).then((result) => {
          if (result.status == 200) {
            const data = result.data
            if (data.success == 1) {
              this.SET_NOTIF_ORDER(Number(data.data))
            } else {
              this.SET_NOTIF_ORDER(0)
            }
          } else {
            this.SET_NOTIF_ORDER(0)
          }
        }).catch((err) => {
          console.warn(err)
          this.SET_NOTIF_ORDER(0)
        });
      } else {
        this.SET_NOTIF_ORDER(0)
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    ...mapGetters("cart", ["GET_CARTS"]),
    ...mapGetters(["GET_ALERT", 'GET_DURATION_OTP']),
    isVerySmall() {
      return window.innerWidth < 640;
    },
    durationOtp: {
      get() {
        return this.GET_DURATION_OTP
      },
      set(value) {
        this.SET_DURATION_OTP(value)
      }
    }
  },
  mounted() {
    if (this.IS_AUTH) {
      this.getCarts(this.GET_USER.id);
    }
    this.getNotif()
  },
  watch: {
    durationOtp: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            --this.durationOtp
          }, 1000);
        }
      },
      immediate: true,
    }
  }
};
</script>